webpackJsonp([1],{

/***/ "+EA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ContentPage__ = __webpack_require__("KRTA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ContentPage: __WEBPACK_IMPORTED_MODULE_0__components_ContentPage__["a" /* default */]
  }
});

/***/ }),

/***/ "/ff6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "099G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__ = __webpack_require__("KVqS");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74787f0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__ = __webpack_require__("Us06");
function injectStyle (ssrContext) {
  __webpack_require__("VUB/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74787f0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74787f0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8zvB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ApaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__("SwRy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b2b39ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__("uCJ3");
function injectStyle (ssrContext) {
  __webpack_require__("oyWA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b2b39ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b2b39ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B5Od":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-light"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{ name: 'home' }}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/images/opnLogo.svg"}}),_vm._v(" "),_c('img',{staticClass:"logo",staticStyle:{"margin-top":"19px"},attrs:{"src":"/static/images/opnText.svg"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                    Forside\n                  ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'product' }}},[_vm._v("\n                    Produkt\n                  ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"display":"none"}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'pricing' }}},[_vm._v("\n                    Pris\n                  ")])],1),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('form',{staticClass:"form-inline"},[_c('router-link',{staticClass:"btn btn-primary try-now",attrs:{"to":{ name: 'sign-up' }}},[_vm._v("Prøv gratis nu")])],1)])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('router-view')],1),_vm._v(" "),_c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-3 centerMobile"},[_c('ul',[_vm._m(3),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Forside")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'product' }}},[_vm._v("Produkt")])],1),_vm._v(" "),_c('li',{staticStyle:{"display":"none"}},[_c('router-link',{attrs:{"to":{ name: 'pricing' }}},[_vm._v("Priser")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'terms-of-service' }}},[_vm._v("\n                Handelsbetingelser\n              ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacy-policy' }}},[_vm._v("\n                Privatlivspolitik\n              ")])],1)])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"https://app.opnx.dk"}},[_vm._v("\n                    Login\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-center"},[_c('img',{staticClass:"footerLogo",attrs:{"src":"/static/images/footer-logo.svg"}}),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"headline"},[_c('span',[_vm._v("Undersider")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3 centerMobile"},[_c('ul',[_c('li',{staticClass:"headline"},[_c('span',[_vm._v("Kontakt")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("70 23 10 23")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("info@generaxion.dk")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("CVR: 31 18 98 10")])])]),_vm._v(" "),_c('div',{staticClass:"social-icons"},[_c('a',{attrs:{"href":"https://www.facebook.com/generaxiondigital","target":"_blank","rel":"noopener noreferrer"}},[_c('span',{staticClass:"fa fa-facebook fa-fw"})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/generaxiondigital/","target":"_blank","rel":"noopener noreferrer"}},[_c('span',{staticClass:"fa fa-instagram fa-fw"})]),_vm._v(" "),_c('a',{attrs:{"href":"https://dk.linkedin.com/company/generaxiondigital","target":"_blank","rel":"noopener noreferrer"}},[_c('span',{staticClass:"fa fa-linkedin fa-fw"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 centerMobile"},[_c('ul',[_c('li',{staticClass:"headline"},[_c('span',[_vm._v("Find vej")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Aarhus")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Sommervej 23A")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("8210 Aarhus V")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 centerMobile"},[_c('ul',[_c('li',{staticClass:"headline hideMobile"},[_c('span',[_vm._v("-")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("København")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Ryesgade 106A")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("2100 København")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DtGu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__ = __webpack_require__("jC9w");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cce16a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__ = __webpack_require__("lS+i");
function injectStyle (ssrContext) {
  __webpack_require__("OUtm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cce16a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cce16a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Du/2":
/***/ (function(module, exports) {



/***/ }),

/***/ "EDI4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FOod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "PageNotFound404",
    computed: {
        to: function to() {
            var route = { name: 'home' };
            return route;
        }
    },
    metaInfo: {
        meta: [{ name: 'robots', content: "noindex" }]
    }
});

/***/ }),

/***/ "FbSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-home"},[_c('div',{staticClass:"hero"},[_c('div',{staticClass:"wrapper container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"crow"}}),_vm._v(" "),_c('p',{staticStyle:{"padding-top":"70px"}},[_vm._v("\n                            OP'N er er et online værktøj,\n                            der giver dig indsigt i din forretning og marketing,\n                            så du kan tage de næste træk for din virksomhed.\n                        ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary try-now",attrs:{"to":{name: 'sign-up'}}},[_vm._v("\n                            Prøv OP'N nu\n                        ")])],1)]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('clients'),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('quotes'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('sign-up')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"showMobile"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"static/images/bgX.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline"},[_c('h1',{staticClass:"h1Insights"},[_vm._v("Insights.\n                            "),_c('span',{attrs:{"id":"typing"}},[_vm._v(" Analyzed.")]),_vm._v(" "),_c('span',{attrs:{"id":"typing2"}},[_vm._v(" Optimized.")]),_vm._v(" "),_c('span',{attrs:{"id":"typing3"}},[_vm._v(" Realized.")]),_vm._v(" "),_c('span',{attrs:{"id":"typing5"}},[_vm._v(" Multiplied.")]),_vm._v(" "),_c('span',{attrs:{"id":"typing4"}},[_vm._v(" Multiplied.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hideMobile",staticStyle:{"position":"absolute","right":"20%","width":"100%","top":"90px"}},[_c('img',{staticStyle:{"width":"700px","opacity":"0.2"},attrs:{"src":"static/images/bgX.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_download container"},[_c('a',{attrs:{"href":"https://apps.apple.com/dk/app/opn-by-generaxion/id1568287211","target":"_blank"}},[_c('div',{staticClass:"app_store"},[_c('div',{staticClass:"left_wrap"},[_c('i',{staticClass:"fa fa-apple",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"right_wrap"},[_c('p',[_vm._v("Tilgængelig på")]),_vm._v(" "),_c('p',[_vm._v("APP Store")])])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.generaxion.opn","target":"_blank"}},[_c('div',{staticClass:"google_play"},[_c('div',{staticClass:"left_wrap"},[_c('img',{attrs:{"src":__webpack_require__("SMD1")}})]),_vm._v(" "),_c('div',{staticClass:"right_wrap"},[_c('p',[_vm._v("Tilgængelig på")]),_vm._v(" "),_c('p',[_vm._v("Google Play")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-wrapper"},[_c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 ml-lg-auto"},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("\n                                Elegant. Overskueligt. Letforståeligt.\n                                OP'N gør det nemt at drive forretning.\n                            ")]),_vm._v(" "),_c('p',[_vm._v("\n                                Med OP'N har vi udviklet et nyt online redskab,\n                                hvor du kan logge ind og se besøg på din hjemmeside,\n                                antal henvendelser, følge dine placeringer på Google,\n                                måle udbyttet af din markedsføring og sammenligne din forretning med andre i branchen.\n                            ")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"integrations"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"content text-center"},[_c('h3',[_vm._v("\n                            Forestil dig, at Google, Facebook, Trustpilot og e-conomic"),_c('br'),_vm._v("\n                            gik sammen om at bygge ét fælles dashboard.\n                        ")]),_vm._v(" "),_c('p',[_vm._v("\n                            OP'N kan integreres med Google, Facebook, Trustpilot, Dinero, e-conomic og mere,\n                            hvilket giver dig fuld indsigt i din virksomheds markedsføring og online tilstedeværelse."),_c('br'),_vm._v("\n                            Er du klar til at tage dit næste træk?\n                        ")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/images/integrations.png"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HB62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            customers: []
        };
    }
});

/***/ }),

/***/ "HXef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("dPB5");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75f8d1f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("FbSP");
function injectStyle (ssrContext) {
  __webpack_require__("Mac1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75f8d1f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75f8d1f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_source__ = __webpack_require__("NH+D");








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */].Store({
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_4__getters__,

    modules: {
        source: __WEBPACK_IMPORTED_MODULE_5__modules_source__["a" /* default */]
    },

    strict: debug
}));

/***/ }),

/***/ "KRTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f988c50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentPage_vue__ = __webpack_require__("xwkN");
function injectStyle (ssrContext) {
  __webpack_require__("WstS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f988c50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f988c50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KVqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Preview__ = __webpack_require__("KvDf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SignUp__ = __webpack_require__("ApaE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Preview: __WEBPACK_IMPORTED_MODULE_0__components_Preview__["a" /* default */],
        SignUp: __WEBPACK_IMPORTED_MODULE_1__components_SignUp__["a" /* default */]
    }
});

/***/ }),

/***/ "KvDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__ = __webpack_require__("fV88");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28df1287_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__ = __webpack_require__("QIpp");
function injectStyle (ssrContext) {
  __webpack_require__("vplJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28df1287"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28df1287_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f1264e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("B5Od");
function injectStyle (ssrContext) {
  __webpack_require__("EDI4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f1264e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MIHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__("hSs9");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e228b7f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__("aG05");
function injectStyle (ssrContext) {
  __webpack_require__("8zvB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e228b7f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e228b7f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Mac1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mrsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__ = __webpack_require__("HB62");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e429a738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__ = __webpack_require__("RumL");
function injectStyle (ssrContext) {
  __webpack_require__("zfAN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e429a738"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e429a738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NH+D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    source: null
};

var getters = {
    getSource: function getSource(state) {
        return state.source;
    }
};

var mutations = {
    setSource: function setSource(state, source) {
        state.source = source;
    }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta__ = __webpack_require__("f3bp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Cookie
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__webpack_require__("K/Lq"));

// Vue-meta
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_meta__["a" /* default */], {
  refreshOnceOnNavigation: true
});

// Vuex




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
  id: 'UA-22606062-4',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OUtm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PbSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfService_vue__ = __webpack_require__("y4dn");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32087fda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfService_vue__ = __webpack_require__("VesA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfService_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32087fda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfService_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QIpp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card",class:{active: _vm.slide === 1},on:{"click":function($event){return _vm.navigate(1)}}},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"card",class:{active: _vm.slide === 2},on:{"click":function($event){return _vm.navigate(2)}}},[_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"card",class:{active: _vm.slide === 3},on:{"click":function($event){return _vm.navigate(3)}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8"},[_c('img',{staticClass:"browser",attrs:{"src":_vm.image}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header text-center"},[_c('h1',[_vm._v("Ét klik giver dig "),_c('span',[_vm._v("meget mere indblik")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('div',{staticClass:"headline"},[_vm._v("\n                                Oversigt\n                            ")]),_vm._v(" "),_c('div',[_vm._v("\n                                Få overblik ved at se udbyttet af din markedsføring, samlet antal besøg og henvendelser og dit omdømme - og find ud af, hvordan det går med din forretning.\n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('div',{staticClass:"headline"},[_vm._v("\n                                SEO, Facebook, Google Ads\n                            ")]),_vm._v(" "),_c('div',[_vm._v("\n                                Dyk dybere ned i din online markedsføring. Se udgifter og udbytte af din SEO, Google Ads, Facebook Ads og følg med i om det går bedre end sidste uge, måned og år.\n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('div',{staticClass:"headline"},[_vm._v("\n                                Kampagner og resultater\n                            ")]),_vm._v(" "),_c('div',[_vm._v("\n                                I de enkelte kanaler har du mulighed for at dykke helt ned i detaljerne. Se eksempelvis performance på enkelte kampagner og de tilknyttede annoncer.\n                            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RumL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clients"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"client d-none d-xl-block"},[_c('img',{attrs:{"src":"/static/images/clients/gunnerdue.png"}})]),_vm._v(" "),_c('div',{staticClass:"client hidden-xs-down"},[_c('img',{attrs:{"src":"/static/images/clients/oris.png"}})]),_vm._v(" "),_c('div',{staticClass:"client d-none d-xl-block"},[_c('img',{attrs:{"src":"/static/images/clients/jupiter-cykler.png"}})]),_vm._v(" "),_c('div',{staticClass:"client d-none d-sm-block"},[_c('img',{attrs:{"src":"/static/images/clients/samsoesamsoe.png"}})]),_vm._v(" "),_c('div',{staticClass:"client d-none d-sm-block"},[_c('img',{attrs:{"src":"/static/images/clients/real.png"}})]),_vm._v(" "),_c('div',{staticClass:"client"},[_c('img',{attrs:{"src":"/static/images/clients/stender.png"}})]),_vm._v(" "),_c('div',{staticClass:"client d-none d-xl-block"},[_c('img',{attrs:{"src":"/static/images/clients/leonpetersen.png"}})])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SMD1":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "SwRy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            email: null,
            domain: null,
            emailError: false,
            domainError: false
        };
    },


    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])({
        source: 'getSource'
    }),

    methods: {
        create: function create() {
            this.emailError = this.email === null;
            this.domainError = this.domain === null;

            if (!this.email || !this.domain) {
                return;
            }

            var url = 'https://app.spotonlive.dk/sign-up?';

            url += 'email=' + encodeURIComponent(this.email) + '&';

            if (this.source) {
                url += 'utm_source=' + encodeURIComponent(this.source) + '&';
            }

            url += 'domain=' + encodeURIComponent(this.domain);

            window.location.href = url;
        }
    }
});

/***/ }),

/***/ "UjVw":
/***/ (function(module, exports) {



/***/ }),

/***/ "Us06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-product"},[_vm._m(0),_vm._v(" "),_c('preview'),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('sign-up')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero"},[_c('div',{staticClass:"container",staticStyle:{"overflow":"hidden!important"}},[_c('div',{staticClass:"text-center hideMobile"},[_c('img',{staticStyle:{"width":"100%","max-width":"800px","opacity":"0.2","position":"absolute","z-index":"1"},attrs:{"src":"/static/images/bgX2.png"}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('div',{staticClass:"content"},[_c('img',{staticStyle:{"width":"100%","max-width":"500px","position":"relative","z-index":"90"},attrs:{"src":"/static/images/laptop_x_iphone.png"}}),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n                            Et nyt, online redskab der giver dig den indsigt du skal bruge til at"),_c('br'),_vm._v("\n                            tage næste træk for din virksomhed. Det er på tide, at I mødes.\n                        ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row row-eq-height row align-items-center"},[_c('div',{staticClass:"col-md-6"},[_c('img',{attrs:{"src":"/static/images/preview-results.jpg"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("Alle resultater samlet ét sted")]),_vm._v(" "),_c('p',[_vm._v("\n                            I OP'N finder du alle svar, du har brug for til at drive din forretning. Log ind og se antal besøg på din hjemmeside, antal henvendelser, dit omdømme og effekten af din markedsføring.\n                        ")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("Se statistikken for besøg på din hjemmeside")]),_vm._v(" "),_c('li',[_vm._v("Se resultatet af dine Google Adwords")]),_vm._v(" "),_c('li',[_vm._v("Se effekten af dine Facebook-annoncer")]),_vm._v(" "),_c('li',[_vm._v("Se gevinsten af din SEO")]),_vm._v(" "),_c('li',[_vm._v("Se udviklingen i henvendelser")]),_vm._v(" "),_c('li',[_vm._v("Følg dit omdømme på internettet")]),_vm._v(" "),_c('li',[_vm._v("Se statistikken for besøg på din hjemmeside")])]),_vm._v(" "),_c('p',[_vm._v("\n                            … og meget mere du kan glæde dig til\n                        ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content text-center"},[_c('h3',[_vm._v("\n                            Se om dine Google-placeringer"),_c('br'),_vm._v("\n                            går frem eller tilbage\n                        ")]),_vm._v(" "),_c('p',[_vm._v("\n                            Med OP'N kan du følge med i dine placeringer på Google inden for søgeord, du selv\n                            vælger. Se nemt og hurtigt udbyttet af dit SEO-arbejde og følg med udviklingen. Hver uge.\n                        ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row row-eq-height row align-items-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("Log ind fra din mobil, tablet og computer")]),_vm._v(" "),_c('p',[_vm._v("\n                            Med OP'N har du altid adgang til de resultater og svar, du har brug for til at drive din forretning. Og svarene er ikke langt væk."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                            Log ind med din personlige bruger fra din mobil, tablet eller computer. Weekend og hverdag. Nat og dag\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('img',{attrs:{"src":"/static/images/laptop_x_iphone.png"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame built-for"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row row-eq-height row align-items-center"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"content text-center"},[_c('h2',[_vm._v("Bygget til lokale virksomheder")]),_vm._v(" "),_c('p',[_vm._v("\n                            OP'N er ikke bygget til eksperter i marketing. Det er bygget til de lokale virksomheder."),_c('br'),_vm._v("\n                            Det garanterer dig, at der kun er ord og oplysninger, du forstår.\n                        ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row row-eq-height row align-items-center"},[_c('div',{staticClass:"col-md-6"},[_c('img',{attrs:{"src":"/static/images/compare-results.jpg"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("Sammenlign dine resultater med andre")]),_vm._v(" "),_c('p',[_vm._v("\n                            Med OP'N har du mulighed for at sammenligne dine resultater med gennemsnittet for branchen."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                            Det giver dig en bedre idé om din forretning klarer sig godt - eller om det er tid til en ny strategi\n                        ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row row-eq-height row align-items-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("Brug dine data til at tage næste træk")]),_vm._v(" "),_c('p',[_vm._v("\n                            Du får en unik og uundværlig indsigt i din markedsføring, hjemmeside og kunder med OP'N."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                            Disse data kan du bruge til at planlægge næste skridt og bygge en strategi, du allerede ved, der kommer til at virke.\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('img',{attrs:{"src":"/static/images/next-move.jpg"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VUB/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VesA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-page',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',[_vm._v("OP'N handelsbetingelser")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n          Nedenfor kan du finde de generelle vilkår for brug af OP'N ydelsen. Vi opfordrer til, at du læser dem grundigt igennem, inden du gør brug af ydelsen.\n      ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Emner:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("Anvendelse")]),_vm._v(" "),_c('li',[_vm._v("Ydelsen")]),_vm._v(" "),_c('li',[_vm._v("Priser og betaling")]),_vm._v(" "),_c('li',[_vm._v("Levering")]),_vm._v(" "),_c('li',[_vm._v("Ansvar")]),_vm._v(" "),_c('li',[_vm._v("Fortrydelse")]),_vm._v(" "),_c('li',[_vm._v("Databehandling")]),_vm._v(" "),_c('li',[_vm._v("Kontakt")]),_vm._v(" "),_c('li',[_vm._v("Lov og værneting")])])]),_vm._v(" "),_c('h2',[_vm._v("Anvendelse")]),_vm._v(" "),_c('p',[_vm._v("\n          Disse handelsbetingelser (herefter kaldet ”Betingelserne”) gælder for alle ydelser der leveres på app.opnx.dk (herefter kaldet ”Servicen”) af OP'N og Generaxion A/S herefter kaldet ”Virksomheden”), som brugere heraf (herefter kaldet ”Brugere”) måtte anvende.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Ydelsen")]),_vm._v(" "),_c('p',[_vm._v("\n          De ydelser/integration, der bliver leveret fra Servicen er afhængige af Brugerens input eller handlinger, hvorfor eventuelle fejl i Brugerens input eller valg ikke er Virksomhedens ansvar. Ligeledes hentes data fra eksterne services ind i Servicen med det formål at Brugeren selv kan tilkoble og frakoble datapunkter. Det er ikke Virksomhedens ansvar at sikre lovligheden af den data der fremhæves for Brugeren. Brugeren kan altid henvende sig til Virksomheden ved tvivlsspørgsmål ift. brug af Servicen.\n      ")]),_vm._v(" "),_c('p',[_vm._v("Brug af Servicen medfølger ikke arbejde af Generaxion A/S medarbejdere ift. optimering af online markedsføringsprodukter eller webudvikling.")]),_vm._v(" "),_c('p',[_vm._v("Servicen har alene til formål at tilbyde Brugeren et overblik over udvalgte datapunkter.")]),_vm._v(" "),_c('h2',[_vm._v("Priser og betaling")]),_vm._v(" "),_c('p',[_vm._v("\n          Servicen tilbydes som freemium, som er gratis at tilgå og anvende. Herudover tilbydes servicen i en udvidet model mod betaling for kr. 199 om måneden. Fakturering heraf følger Virksomhedens generelle leveringsbetingelser.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Levering")]),_vm._v(" "),_c('p',[_vm._v("\n          Når Brugeren har oprettet en konto, har Brugeren adgang til Servicen via login på app.opnx.dk. Adgang til Servicen ophører hvis Brugeren sletter sin konto.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Ansvar")]),_vm._v(" "),_c('p',[_vm._v("\n          Virksomheden er i intet tilfælde ansvarlige for Brugerens viste data, lovligheden af forbundne datapunkter, de informationer der vises for Brugeren eller hvad Brugeren anvender viste datainformationer til. Virksomheden fraskriver sig desuden ethvert ansvar i situationer, der må betegnes som force majeure lignende, fx strejke, pandemi, brand, naturkatastrofer, afbrydelser og/eller svigt i energiforsyning og/eller kommunikationssystemer.\n      ")]),_vm._v(" "),_c('p',[_vm._v("Brugeren er alene ansvarlig for informationerne på deres profil er korrekte og at de valgte integrationer er forbundet til datapunkter som Brugeren har lovlig adgang til.")]),_vm._v(" "),_c('p',[_vm._v("Virksomheden fraskriver sig ethvert ansvar for hvad Brugeren vælger at bruge Servicen til.")]),_vm._v(" "),_c('h2',[_vm._v("Fortrydelse")]),_vm._v(" "),_c('p',[_vm._v("Brugeren kan selv eller ved kontakt til Virksomheden få slettet sin adgang til Servicen. Ved betalt adgang gælder Generaxion A/S normale betalingsbetingelser.")]),_vm._v(" "),_c('h2',[_vm._v("Databehandling")]),_vm._v(" "),_c('p',[_vm._v("\n          Her følges OP'Ns "),_c('router-link',{attrs:{"to":{name: 'privacy-policy'}}},[_vm._v("privatlivs- og cookiepolitik.")])],1),_vm._v(" "),_c('h2',[_vm._v("Kontakt")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Servicen OP'N udbydes og drives af:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          Generaxion\n          "),_c('br'),_vm._v("\n          Sommervej 23A\n          "),_c('br'),_vm._v("\n          DK-8210 Aarhus V\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          Cvr nr: 31 18 98 10\n          "),_c('br'),_vm._v("\n          Tlfnr : 70 23 10 23\n          "),_c('br'),_vm._v("\n          E-mail: info@generaxion.dk\n          "),_c('br'),_vm._v("\n          Etableringsår: 2008\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Lov og værneting")]),_vm._v(" "),_c('p',[_vm._v("Enhver tvist som måtte udspringe af Brugerens anvendelse af Servicen skal anlægges ved Byretten i Aarhus. Tvisten afgøres efter dansk ret.  ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WstS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',

  routes: [{
    path: '/',
    name: 'home',
    component: __webpack_require__("HXef").default
  }, {
    path: '/product',
    name: 'product',
    component: __webpack_require__("099G").default
  }, {
    path: '/pricing',
    name: 'pricing',
    component: __webpack_require__("DtGu").default
  }, {
    path: '/sign-up',
    name: 'sign-up',
    component: __webpack_require__("MIHL").default
  }, {
    path: '/terms-of-service',
    name: 'terms-of-service',
    component: __webpack_require__("PbSG").default
  }, {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: __webpack_require__("jXXe").default
  }, {
    path: '*',
    name: 'errors.404',
    component: __webpack_require__("oNIu").default
  }]
}));

/***/ }),

/***/ "aG05":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-sign-up"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"sign-up"},[_c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-xl-6 col-md-8 col-sm-10"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.emailError},attrs:{"type":"text","placeholder":"Din e-mail"},domProps:{"value":(_vm.email)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.create($event)},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.domain),expression:"domain"}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.domainError},attrs:{"type":"text","placeholder":"Din hjemmeside"},domProps:{"value":(_vm.domain)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.create($event)},"input":function($event){if($event.target.composing){ return; }_vm.domain=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-primary btn-lg btn-block try-now lead-trigger",attrs:{"type":"button"},on:{"click":_vm.create}},[_vm._v("\n                                Start gratis nu\n                            ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('h1',[_vm._v("100% gratis, så længe du har lyst")]),_vm._v(" "),_c('p',[_vm._v("\n                    Med OP'N kan du finde de svar, du har brug for til at drive forretning i en digital tid.\n                    Prøv det nye online værktøj allerede i dag og se, hvor smart OP'N egentlig er. Det er gratis.\n                ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aIdc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aY2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            show: 1,

            quotes: [{
                image: '/static/images/quotes/nisjensen.png',
                author: 'Nis Jensen',
                employment: 'Digital Marketingschef hos Admiral Hotel',
                description: 'OPN er blevet et redskab, vi bruger på lige fod med andre værktøjer i vores marketingafdeling til overblik og optimering af indsatser og processer'
            }, {
                image: '/static/images/quotes/nielsfuglsang.png',
                author: 'Niels Fuglsang',
                employment: 'Advokat hos Sønderby Legal',
                description: 'I en travl hverdag har det været rart, at vi på kort tid kan følge med i om vores hjemmeside og markedsføring skaber resultater. Også når vi er på farten!'
            }, {
                image: '/static/images/quotes/idasalomonsson.png',
                author: 'Ida Oxenvad',
                employment: 'Indehaver af Københavns Kropterapeut',
                description: 'Ofte synes jeg, at det kan være svært at bruge og forstå de grafer, der vises i et redskab til marketing. Men OPN var simpelt og overskueligt. Jeg kunne rent faktisk nemt se, hvor jeg kunne blive bedre'
            }]
        };
    },


    computed: {
        total: function total() {
            return this.quotes.length;
        },
        quote: function quote() {
            return this.quotes[this.show - 1];
        }
    },

    methods: {
        next: function next() {
            if (this.show === this.total) {
                this.show = 1;

                return;
            }

            this.show++;
        },
        previous: function previous() {
            if (this.show === 1) {
                this.show = this.total;

                return;
            }

            this.show--;
        }
    }
});

/***/ }),

/***/ "awhP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quotes_vue__ = __webpack_require__("aY2b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ab36a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quotes_vue__ = __webpack_require__("zJKy");
function injectStyle (ssrContext) {
  __webpack_require__("/ff6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09ab36a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quotes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ab36a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quotes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c8O6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            show: 1,

            quotes: [{
                image: '/static/images/quotes/nis.png',
                author: 'Nis Jensen',
                employment: 'Digital Marketingschef hos Admiral Hotel',
                description: "OP'N er blevet et redskab, vi bruger på lige fod med andre værktøjer i vores marketingafdeling til overblik og optimering af indsatser og processer"
            }, {
                image: '/static/images/quotes/nis.png',
                author: 'Simon Salomonsson',
                employment: "CEO hos OP'N Marketing ApS",
                description: 'Hej med dig'
            }]
        };
    },


    computed: {
        total: function total() {
            return this.quotes.length;
        },
        quote: function quote() {
            return this.quotes[this.show - 1];
        }
    },

    methods: {
        next: function next() {
            if (this.show === this.total) {
                this.show = 1;

                return;
            }

            this.show++;
        },
        previous: function previous() {
            if (this.show === 1) {
                this.show = this.total;

                return;
            }

            this.show--;
        }
    }
});

/***/ }),

/***/ "dPB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Clients__ = __webpack_require__("Mrsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Quotes__ = __webpack_require__("awhP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SignUp__ = __webpack_require__("ApaE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Clients: __WEBPACK_IMPORTED_MODULE_0__components_Clients__["a" /* default */],
        Quotes: __WEBPACK_IMPORTED_MODULE_1__components_Quotes__["a" /* default */],
        SignUp: __WEBPACK_IMPORTED_MODULE_2__components_SignUp__["a" /* default */]
    }
});

/***/ }),

/***/ "fV88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            slide: 1
        };
    },


    computed: {
        image: function image() {
            return '/static/images/switcher/browser_' + this.slide + '.png';
        }
    },

    methods: {
        navigate: function navigate(slide) {
            this.slide = slide;
        }
    }
});

/***/ }),

/***/ "hSs9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            email: null,
            domain: null,
            emailError: false,
            domainError: false
        };
    },


    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])({
        source: 'getSource'
    }),

    methods: {
        create: function create() {
            this.emailError = this.email === null;
            this.domainError = this.domain === null;

            if (!this.email || !this.domain) {
                return;
            }

            var url = 'https://app.opnx.dk/sign-up?';

            url += 'email=' + encodeURIComponent(this.email) + '&';

            if (this.source) {
                url += 'utm_source=' + encodeURIComponent(this.source) + '&';
            }

            url += 'domain=' + encodeURIComponent(this.domain);

            window.location.href = url;
        }
    }
});

/***/ }),

/***/ "hb4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-page',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',[_vm._v("OP'N privatlivspolitik")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("OP'N indgår som serviceydelse i Generaxion A/S. Privatlivspolitikken her vedrører brugen af persondata i OP'N og den data der indsamles ved brugen af OP'N servicen.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Emner:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("Vores service")]),_vm._v(" "),_c('li',[_vm._v("Hvilke data indsamler vi? ")]),_vm._v(" "),_c('li',[_vm._v("Hvordan bruger vi dine informationer?")]),_vm._v(" "),_c('li',[_vm._v("Dine rettigheder ift. den information vi har på dig ")]),_vm._v(" "),_c('li',[_vm._v("Hvem har adgang til dine informationer? ")]),_vm._v(" "),_c('li',[_vm._v("Hvordan er din data beskyttet? ")]),_vm._v(" "),_c('li',[_vm._v("Hvor længe opbevares dine informationer? ")]),_vm._v(" "),_c('li',[_vm._v("Cookies")]),_vm._v(" "),_c('li',[_vm._v("GDPR")]),_vm._v(" "),_c('li',[_vm._v("Dataansvarlig")])])]),_vm._v(" "),_c('h2',[_vm._v("Vores service")]),_vm._v(" "),_c('p',[_vm._v("OP'N tilbyder et dashboard hvorfra data fra tilknyttede sociale medier, søgemaskiner m. fl. kan præsenteres til afrapporterings- og analyseformål.")]),_vm._v(" "),_c('p',[_vm._v("Enhver indsamling, brug og håndtering af personlig information fra tilknyttede kanaler i OP'N følger disses respektive privatlivspolitikker og betingelser.")]),_vm._v(" "),_c('p',[_vm._v("OP'N muliggøre forbindelse af 3. parts services, herunder applikationer, som kan tilknyttes og vises i dashboarded. Indsamling af dine informationer i relation til disse 3. parts services er håndteret og følger 3. parts privatlivspoilitikker og betingelser. OP'N er ikke ansvarlige for 3. parts service, databehandling eller lign. ")]),_vm._v(" "),_c('p',[_vm._v("Herfra også omtalt som ”servicen”.")]),_vm._v(" "),_c('h2',[_vm._v("Hvilke data indsamler vi?")]),_vm._v(" "),_c('p',[_vm._v("OP'N indsamler følgende information ifm. din brug af vores service.")]),_vm._v(" "),_c('h4',[_vm._v("Kontoinformation")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Dine kontakt- og profiloplysninger herunder navn, e-mail, telefonnummer, organisationsnavn, CVR, domæne URL")]),_vm._v(" "),_c('li',[_vm._v("Vi kan også indsamle denne information igennem social login services som Google, Facebook og Microsoft")])])]),_vm._v(" "),_c('h4',[_vm._v("Indhold")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Dine social profile information for sociale netværk, hvis disse er brugt til at forbinde til vores service. ")]),_vm._v(" "),_c('li',[_vm._v("En adresse, hvis du vælger at dele denne information.")])])]),_vm._v(" "),_c('h4',[_vm._v("Log-, brugs- og supportdata")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Log data kan inkluderer din IP adresse, browser type og indstillinger, din enhedsinformation, dato og tidspunkt for brug af servicen, information om browser konfiguration, sprog præference, unikke identifikationer og cookies.")])])]),_vm._v(" "),_c('h4',[_vm._v("Brug af hjemmesiden")]),_vm._v(" "),_c('p',[_vm._v("Når du anvender vores hjemmeside app.opnx.dk indsamler vi følgende informationer, som indsamles automatisk. ")]),_vm._v(" "),_c('p',[_vm._v("OP'N anvender cookies og lignende sporingsteknologier så som, pixels og tokens, til at muliggøre servicen. Disse er beskrevet i sektionen cookies.")]),_vm._v(" "),_c('h2',[_vm._v("Hvordan bruger vi dine informationer?")]),_vm._v(" "),_c('p',[_vm._v("Vi bruger dine informationer til følgende formål:")]),_vm._v(" "),_c('h4',[_vm._v("Til at tilbyde og sikre vores service")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Vi har brug for at identificere og bekræfte vores brugere for at sikre, eksempelvis, at det kun er autoriserede brugere som er i stand til at bruge vores service.")]),_vm._v(" "),_c('li',[_vm._v("Vi bruger informationen du angiver ifm. login til servicen, samt for at kunne kontakte dig ifm. support af servicen, samt til at håndtere din konto. ")]),_vm._v(" "),_c('li',[_vm._v("Vi bruger logging og anden data, såsom generel lokation, f. eks. IP adresse af din browser og enhed, til at hjælpe os med at håndtere performance, sikkerhed og stabilitet på servicen.")]),_vm._v(" "),_c('li',[_vm._v("Vi analysere brugen af servicen, support forespørgsler m. fl. til at hjælpe os til at forstå brugen af servicen med det formål at tilbyde løbende forbedringer og optimeringer til servicen.")])])]),_vm._v(" "),_c('h4',[_vm._v("Kommunikation med dig")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Vi bruger dine kontaktinformationer til at tage kontakt til dig i tilfælde hvor direkte kontakt til vores support er nødvendig for at afhjælpe et teknisk problem.")]),_vm._v(" "),_c('li',[_vm._v("Ligeledes vil du, i kraft af din brug af servicen, modtager månedlige status- og statistikrapporter som en del af servicen til den e-mail som er angivet")]),_vm._v(" "),_c('li',[_vm._v("Afslutningsvis, kan dine kontaktinformationer bliver brugt til markedsføringsformål for servicen og Generaxion A/S nyhedsbreve, marketing automation o. lign.")])])]),_vm._v(" "),_c('h4',[_vm._v("Forbedring af vores hjemmeside og applikationer")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Vi bruger informationer vi modtager fra dig til at forstå brugsmønstre og andre aktiviteter på vores hjemmeside og applikationer, så vi kan diagnosticere problemer og foretage forbedringer, herunder styrker brugerfladen og sikkerhed")])])]),_vm._v(" "),_c('h2',[_vm._v("Dine rettigheder ift. den information vi har på dig")]),_vm._v(" "),_c('p',[_vm._v("Følgende kortlægger dine rettigheder ift. den information vi har på dig ifm. brug af vores service. ")]),_vm._v(" "),_c('h4',[_vm._v("Service information")]),_vm._v(" "),_c('p',[_vm._v("Når du bruger vores service, må du tilgå, opdatere og rette det meste af dine kontoinformationer ved at logge ind på din konto og redigere din profil. ")]),_vm._v(" "),_c('p',[_vm._v("Hvis dine ønskede ændringer ikke kan udføres ved at logge ind på din konto, så som at tilgå mere information eller slette information om dig, bedes du kontakte din Generaxion A/S Strategy Specialist eller Generaxion A/S på "),_c('a',{attrs:{"href":"mailto:info@generaxion.dk"}},[_vm._v("info@generaxion.dk")]),_vm._v(". Vi kan være nødsaget til at tilbageholde noget information omkring dig så længe du anvender vores service, for at du kan anvende vores service.")]),_vm._v(" "),_c('p',[_vm._v("Du kan kontakte Generaxion A/S for generelle henvendelser og eller support vedr. din servicekonto. ")]),_vm._v(" "),_c('h4',[_vm._v("Marketing emails, markedsføring og brug af hjemmeside")]),_vm._v(" "),_c('p',[_vm._v("Ved brug af vores service accepterer du at Generaxion A/S må kontakte dig med markedsføringsrelateret indhold. ")]),_vm._v(" "),_c('h2',[_vm._v("Hvem har adgang til dine informationer?")]),_vm._v(" "),_c('p',[_vm._v("OP'N udlejer eller sælger ikke dine informationer. Vi begrænser adgang til dine informationer til autoriserede medarbejdere og vi deler ikke dine informationer med 3. part foruden i situationer som beskrevet herunder.")]),_vm._v(" "),_c('h4',[_vm._v("Medarbejdere og autoriserede underleverandører")]),_vm._v(" "),_c('p',[_vm._v("Vores medarbejdere og autoriserede underleverandører kan have behov for at tilgå information om dig når de skal udføre deres arbejde. F. eks. kan support have behov for at tilgå din konto for at validere din identitet samt svare på support- eller generelle spørgsmål; I tilfælde hvor du, foruden brug af vores service, også er kunde hos Generaxion A/S, vil Generaxions medarbejdere kunne have behov for at tilgå jeres konto for at foretage afrapportering og optimering af jeres markedsføringsaktiviteter.")]),_vm._v(" "),_c('p',[_vm._v("Alle vores medarbejdere og underleverandører påkræves fortrolighed omkring dine data og informationer.")]),_vm._v(" "),_c('h4',[_vm._v("Sociale netværk og tredje parts services")]),_vm._v(" "),_c('p',[_vm._v("I de situationer hvor din servicekonto er forbundet til 3. parts serviceydelser, så som sociale netværk, google m. fl, autoriseres adgang til dine informationer for at indhente dataen til dit dashboard på din servicekonto.")]),_vm._v(" "),_c('h2',[_vm._v("Hvordan er din data beskyttet?")]),_vm._v(" "),_c('p',[_vm._v("OP'N holder industristandard sikkerhedsforanstaltninger for at beskytte dine data og informationer. Dette inkluderer at sikre at vores medarbejdere modtager den fornødne træning i sikkerhed og privatlivsinformationshåndtering og besidder den fornødne viden og vejledning til at sikre at dine data og informationer beskyttes.")]),_vm._v(" "),_c('p',[_vm._v("Vores service er beskyttet af adgangskontrol for at begrænse adgang til dine data og informationer, så disse kun er tilgængelige for de medarbejdere som skal bruge disse til at udføre deres arbejde.")]),_vm._v(" "),_c('p',[_vm._v("Vi krypterer data hvor dette er nødvendigt, så din information holdes privat.")]),_vm._v(" "),_c('h2',[_vm._v("Hvor længe opbevares dine informationer?")]),_vm._v(" "),_c('p',[_vm._v("Generelt opbevare OP'N dine informationer i det tidsrum hvor din konto er aktiv på vores netværk. ")]),_vm._v(" "),_c('p',[_vm._v("Vi opbevarer kun dine informationer i det tidsrum det er nødvendigt for at du kan bruge vores service, for statistik formål og for eventuelle juridiske forpligtelser som måtte følge af vores handelsbetingelser.")]),_vm._v(" "),_c('p',[_vm._v("Såfremt kontoen lukkes helt slettes din data. Dette kan anmodes ved at kontakte Generaxion A/S på "),_c('a',{attrs:{"href":"mailto:info@generaxion.dk"}},[_vm._v("info@generaxion.dk")]),_vm._v(".")]),_vm._v(" "),_c('h2',[_vm._v("Cookies")]),_vm._v(" "),_c('p',[_vm._v("Ved brug af OP'N anvendes følgende cookies:")]),_vm._v(" "),_c('p',[_vm._v("\n          opnx.dk\n          "),_c('br'),_vm._v("\n          _cfduid\n          "),_c('br'),_vm._v("\n          __mp_opt_in_out_ee7099b894bd6afebe7ad7e0e55185ab\n          "),_c('br'),_vm._v("\n          _fbp\n          "),_c('br'),_vm._v("\n          _ga\n          "),_c('br'),_vm._v("\n          _gat\n          "),_c('br'),_vm._v("\n          _gid\n          "),_c('br'),_vm._v("\n          mp_ee7099b894bd6afebe7ad7e0e55185ab_mixpanel\n      ")]),_vm._v(" "),_c('h2',[_vm._v("GDPR")]),_vm._v(" "),_c('p',[_vm._v("Alt efter situationen kan OP'N agere data behandler eller data formidler.")]),_vm._v(" "),_c('h4',[_vm._v("OP'N som databehandler")]),_vm._v(" "),_c('p',[_vm._v("OP'N fungerer som databehandler når vi:")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Indsamler information til opsætning og administration af din servicekonto")]),_vm._v(" "),_c('li',[_vm._v("Overvågning af brugen af information på vores website")]),_vm._v(" "),_c('li',[_vm._v("Håndtering af kontakt og anden relateret information til at sende marketing, service og anden kommunikation til dig")]),_vm._v(" "),_c('li',[_vm._v("Håndtering af supportrelevante og eller generelle service spørgsmål")])])]),_vm._v(" "),_c('h4',[_vm._v("Samtykke grundlag for OP'N som databehandler")]),_vm._v(" "),_c('p',[_vm._v("Grundlag for OP'N som databehandler inkluderer:")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Ved at bruge vores service giver du samtykke til at vi kan behandle dine informationer og data med det formål at levere den ønskede service.")]),_vm._v(" "),_c('li',[_vm._v("Der kan forekomme juridiske forpligtelser som gør det nødvendigt at OP'N behandler dine data.")])])]),_vm._v(" "),_c('h4',[_vm._v("Dine rettigheder når OP'N er din databehandler")]),_vm._v(" "),_c('p',[_vm._v("Når OP'N er databehandler er følgende rettigheder gældende for dig")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Du er i din fulde ret til at opsige eller slette din servicekonto, hvorved adgang til servicen ikke længere er givet og dine data slettes.")]),_vm._v(" "),_c('li',[_vm._v("Du er i din fulde ret til at opsøge mere information om den data og information der opbevares ved brug af servicen.")]),_vm._v(" "),_c('li',[_vm._v("Du kan frit ændrer i den data og information vi opbevarer for dig inden for hvad der kan lade sig gøre med standard servicekonto adgang. Skulle du ønske at ændrer information som ikke er muligt med din servicekonto adgang bedes du kontakte OP'N support via Generaxion A/S.")])])]),_vm._v(" "),_c('h4',[_vm._v("OP'N som dataformidler")]),_vm._v(" "),_c('p',[_vm._v("\n          Hele servicens primære formål er at fungerer som dataformidler, hvor eksterne services så som Facebook API, Google API m.v. hentes og præsenteres for brugeren af OP'N til præsentation og afrapporteringsformål i et samlet dashboard.\n      ")]),_vm._v(" "),_c('p',[_vm._v("Ved brug af servicen kan du frit forbinde til eksterne services, for at indhente dine data til afrapportering. OP'N formidler dataen i det omfang det er muligt, men er ikke ansvarlige for den viste data. Her fungerer servicen udelukkende som formidler.")]),_vm._v(" "),_c('p',[_vm._v("Det er hverken OP'Ns eller Generaxion A/S ansvar at sikre at den indhentede data fra tilknyttede eksterne services, eksempelvis fra google analytics api, er indsamlet jf. gældende GDPR lovgivning og brugersamtykke.")]),_vm._v(" "),_c('h2',[_vm._v("OP'N Dataansvarlig")]),_vm._v(" "),_c('p',[_vm._v("Servicen OP'N udbydes og drives af:")]),_vm._v(" "),_c('p',[_vm._v("Websitet generaxion.dk udbydes og drives af:")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Generaxion")]),_vm._v(" "),_c('br'),_vm._v("\n          Sommervej 23A\n          "),_c('br'),_vm._v("\n          DK-8210 Aarhus V\n          "),_c('br'),_c('br'),_vm._v("\n          Cvr nr: 31 18 98 10\n          "),_c('br'),_vm._v("\n          Tlfnr : 70 23 10 23\n          "),_c('br'),_vm._v("\n          E-mail: info@generaxion.dk\n          "),_c('br'),_vm._v("\n          Etableringsår: 2008\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jC9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PricingTables__ = __webpack_require__("jPrV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        PricingTables: __WEBPACK_IMPORTED_MODULE_0__components_PricingTables__["a" /* default */]
    }
});

/***/ }),

/***/ "jPrV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingTables_vue__ = __webpack_require__("c8O6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eef533ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingTables_vue__ = __webpack_require__("wL1f");
function injectStyle (ssrContext) {
  __webpack_require__("aIdc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eef533ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eef533ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jXXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__("+EA3");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_984f7f1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__("hb4T");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_984f7f1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lS+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-pricing"},[_vm._m(0),_vm._v(" "),_c('pricing-tables')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('h1',[_vm._v("Vi synes selv, at det er fair.")]),_vm._v(" "),_c('p',[_vm._v("\n                    OP'N er 100% gratis for alle. Vi kræver kun et fast månedsbeløb, hvis du vil opgradere\n                    og bruge alle OP'N's  muligheder, da vi skal betale en tredjepart for disse funktioner.\n                    Det synes vi er fair.\n                ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mutation_types__);


/***/ }),

/***/ "oNIu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound404_vue__ = __webpack_require__("FOod");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b3e579_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound404_vue__ = __webpack_require__("pP3I");
function injectStyle (ssrContext) {
  __webpack_require__("oWgp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56b3e579"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b3e579_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oWgp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oyWA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pP3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-wrap"},[_c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('h3',[_vm._v("Siden blev ikke fundet")]),_vm._v(" "),_c('router-link',{staticClass:"return-button",attrs:{"to":_vm.to}},[_vm._v("Klik her for at gå til forsiden")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uCJ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-up"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center controls"},[_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.emailError},attrs:{"type":"text","placeholder":"Din e-mail"},domProps:{"value":(_vm.email)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.create($event)},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.domain),expression:"domain"}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.domainError},attrs:{"type":"text","placeholder":"Din hjemmeside"},domProps:{"value":(_vm.domain)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.create($event)},"input":function($event){if($event.target.composing){ return; }_vm.domain=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-2"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn btn-outline-light btn-lg col-sm-auto col-sm-auto lead-trigger",on:{"click":_vm.create}},[_vm._v("\n                        Kom igang\n                    ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('h2',{staticClass:"headline"},[_vm._v("100% gratis, så længe du har lyst")]),_vm._v(" "),_c('p',[_vm._v("\n                    Prøv OP'N i dag - og få fuld indsigt,\n                    så du kan tage næste træk for din virksomhed\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vplJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wL1f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricing-tables"},[_c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-xl-5 col-md-6 col-sm-12 col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body text-center"},[_c('h4',{staticClass:"card-title text-uppercase"},[_vm._v("\n                                Basis\n                            ")]),_vm._v(" "),_c('p',{staticClass:"description card-text text-center"},[_vm._v("\n                                Til dig, der vil bruge OP'N og de mange muligheder så længe du har lyst\n                            ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary sign-up",attrs:{"to":{name: 'sign-up'}}},[_vm._v("\n                                Prøv OP'N nu\n                            ")])],1),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 col-md-6 col-sm-12 col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body text-center"},[_c('h4',{staticClass:"card-title text-uppercase"},[_vm._v("\n                                Business\n                            ")]),_vm._v(" "),_c('p',{staticClass:"description card-text text-center"},[_vm._v("\n                                Til dig, der vil opnå fuld indsigt i kommunikationen med dine nye og eksisterende kunder\n                            ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary sign-up",attrs:{"to":{name: 'sign-up'}}},[_vm._v("\n                                Prøv gratis i 30 dage\n                            ")])],1),_vm._v(" "),_vm._m(3)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"price card-text"},[_c('span',{staticClass:"currency"},[_vm._v("DKK")]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("0")]),_vm._v(" "),_c('span',{staticClass:"month text-muted"},[_vm._v("/ måned")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"features card-body"},[_c('ul',[_c('li',[_vm._v("Søgeordsovervågning")]),_vm._v(" "),_c('li',[_vm._v("Hjemmesidestatistik")]),_vm._v(" "),_c('li',[_vm._v("Tracking af anmeldelser")]),_vm._v(" "),_c('li',[_vm._v("Tracking af annoncer")]),_vm._v(" "),_c('li',[_vm._v("Opkobling til økonomisystem")]),_vm._v(" "),_c('li',[_vm._v("E-mail tracking")]),_vm._v(" "),_c('li',[_c('s',[_vm._v("Opkaldstracking")]),_c('br'),_vm._v(" "),_c('small',[_c('s',[_vm._v("inkl. 100 minutters opkald")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"price card-text"},[_c('span',{staticClass:"currency"},[_vm._v("DKK")]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("199")]),_vm._v(" "),_c('span',{staticClass:"month text-muted"},[_vm._v("/ måned")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"features card-body"},[_c('ul',[_c('li',[_vm._v("Søgeordsovervågning")]),_vm._v(" "),_c('li',[_vm._v("Hjemmesidestatistik")]),_vm._v(" "),_c('li',[_vm._v("Tracking af anmeldelser")]),_vm._v(" "),_c('li',[_vm._v("Tracking af annoncer")]),_vm._v(" "),_c('li',[_vm._v("Opkobling til økonomisystem")]),_vm._v(" "),_c('li',[_vm._v("E-mail tracking")]),_vm._v(" "),_c('li',[_vm._v("\n                                    Opkaldstracking"),_c('br'),_vm._v(" "),_c('small',[_vm._v("inkl. 100 minutters opkald")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__("Bb4J");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  watch: {
    $route: function $route() {
      window.scrollTo(0, 0);

      if ($(".navbar-collapse").hasClass("show")) {
        $(".navbar-toggler").click();
      }
    }
  },

  beforeMount: function beforeMount() {
    this.checkForIdentity();
    this.checkForQueryParams();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])({
    setSource: "setSource"
  }), {
    checkForIdentity: function checkForIdentity() {
      var signedIn = this.$cookie.get("signedIn") !== null;

      if (!signedIn) {
        return;
      }

      window.location.href = "https://app.spotonlive.dk";
    },
    checkForQueryParams: function checkForQueryParams() {
      var route = this.$route;

      if (!route || !route.query) {
        return;
      }

      var query = route.query;

      if (query.utm_source) {
        this.setSource(query.utm_source);

        this.$router.replace({
          query: {}
        });
      }
    }
  })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "xwkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-page"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y4dn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ContentPage__ = __webpack_require__("KRTA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ContentPage: __WEBPACK_IMPORTED_MODULE_0__components_ContentPage__["a" /* default */]
  }
});

/***/ }),

/***/ "zJKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quotes"},[_c('div',{staticClass:"controls"},[_c('a',{staticClass:"previous",on:{"click":_vm.previous}},[_c('span',{staticClass:"fa fa-angle-left fa-fw"})]),_vm._v(" "),_c('a',{staticClass:"next",on:{"click":_vm.next}},[_c('span',{staticClass:"fa fa-angle-right fa-fw"})])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-7 col-md-9 col-sm-12 col-xs-12"},[_c('div',{staticClass:"quote"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"media"},[_c('img',{staticClass:"d-flex align-self-start mr-3 author",attrs:{"src":_vm.quote.image,"alt":"Generic placeholder image"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('div',[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.quote.author))]),_vm._v(" "),_c('span',{staticClass:"employment"},[_vm._v(_vm._s(_vm.quote.employment))])])])]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("\n                            \""+_vm._s(_vm.quote.description)+"\"\n                        ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zfAN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7c7da6f0f3308037deab.js